export class BatchUpdateLlgPolicyItem {
    'logSourceId';
    'policy';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "logSourceId",
            "baseName": "logSourceId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "policy",
            "baseName": "policy",
            "type": "LlgResourcePolicy",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BatchUpdateLlgPolicyItem.attributeTypeMap;
    }
    constructor() {
    }
}
